import RightMenus from "./RightMenus";
import UserInfo from "./UserInfo";

const ContainerHeader = () => {
  return (
    <div className="border-b h-[65px] sm:px-2 md:px-5 flex items-center justify-between bg-white">
      <UserInfo />
      <RightMenus />
    </div>
  );
};

export default ContainerHeader;
